import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Checkbox, FieldLabel, FlexBox, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import noop from 'lodash/noop';
import { useState } from 'react';
import { createAppModal } from 'utils/modal';
import styles from './confirmModal.module.scss';
/** A component that displays a confirm modal. */
export const ConfirmModal = createAppModal({ type: 'app:confirm' }, ({ isOpen, modal, meta, hide = noop }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [confirm, setConfirm] = useState();
    /** Handles executing the confirm action. */
    const handleExecuteConfirm = (confirmFn) => {
        const action = confirmFn !== null && confirmFn !== void 0 ? confirmFn : confirm;
        if (action) {
            action()
                .then(hide)
                .catch(() => {
                setIsLoading(false);
            });
        }
    };
    /** Handles confirming the modal. */
    const handleConfirm = (confirmFn) => {
        setConfirm(() => confirmFn);
        handleExecuteConfirm(confirmFn);
    };
    /** Handles confirming the modal. */
    const handleModalConfirm = () => {
        var _a;
        if (meta) {
            if ((_a = modal.arg.confirm) === null || _a === void 0 ? void 0 : _a.async) {
                setIsLoading(true);
            }
            else {
                handleHide();
            }
            if (confirm) {
                handleExecuteConfirm();
            }
            else {
                meta.resolve({
                    isConfirmed: true,
                    isCancelled: false,
                    hide: handleHide,
                    confirm: handleConfirm,
                    isCheckboxChecked,
                });
            }
        }
    };
    /** Handles hiding the modal. */
    const handleHide = () => {
        hide === null || hide === void 0 ? void 0 : hide();
    };
    /** Handles cancelling the modal. */
    const handleModalCancel = () => {
        if (meta) {
            handleHide();
            meta.resolve({
                isConfirmed: false,
                isCancelled: true,
                hide: handleHide,
                confirm: handleConfirm,
                isCheckboxChecked,
            });
        }
    };
    return (_jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: handleModalCancel, className: styles.root }, { children: [_jsx(ModalHead, { title: modal.arg.title, onClose: handleModalCancel }), _jsx(ModalBody, { children: modal.arg.description }), _jsx(ModalFoot, Object.assign({ confirmOnClick: handleModalConfirm, cancelOnClick: handleModalCancel, cancelName: (_b = (_a = modal.arg.cancel) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : 'Cancel', confirmName: (_d = (_c = modal.arg.confirm) === null || _c === void 0 ? void 0 : _c.label) !== null && _d !== void 0 ? _d : 'Confirm', confirmProps: {
                    variant: (_f = (_e = modal.arg.confirm) === null || _e === void 0 ? void 0 : _e.variant) !== null && _f !== void 0 ? _f : 'danger',
                    loadingIndicator: (_g = modal.arg.confirm) === null || _g === void 0 ? void 0 : _g.asyncLabel,
                    isLoading,
                }, cancelProps: {
                    disabled: isLoading,
                } }, { children: ((_h = modal.arg.checkbox) === null || _h === void 0 ? void 0 : _h.label) && (_jsx(FlexBox, Object.assign({ flex: "1", alignItems: "center", justifyContent: "start" }, { children: _jsxs(FieldLabel, { children: [_jsx(Checkbox, { name: "confirmModalCheckbox", checked: isCheckboxChecked, onChange: () => setIsCheckboxChecked((isCheckboxChecked) => !isCheckboxChecked) }), _jsx(Box, Object.assign({ as: "span", margin: "100" }, { children: modal.arg.checkbox.label }))] }) }))) }))] })));
});
